import { customerName, displayedTitle, id } from '~/models/relationship-summary/selectors';
const isBlank = (value)=>value.trim() === '';
const DEFAULT_AGREEMENT_LABEL_SEPARATOR = ' — ';
const PLACEHOLDER_AGREEMENT_TITLES = new Set([
    'agreement',
    'untitled agreement'
]);
const isPlaceholderTitle = (title)=>PLACEHOLDER_AGREEMENT_TITLES.has(title.trim().toLowerCase());
export const agreementLabel = function agreementLabel(rel) {
    let separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_AGREEMENT_LABEL_SEPARATOR;
    const base = customerName(rel);
    const title = displayedTitle(rel, true);
    return title == null || isBlank(title) || title === base || isPlaceholderTitle(title) ? base : "".concat(base).concat(separator).concat(title);
};
export const buildEntityMaps = (clients, agreements, agreementSeparator)=>({
        clientMap: new Map(clients.map((client)=>[
                client.clientId(),
                client.name()
            ])),
        agreementMap: new Map(agreements.map((rel)=>[
                id(rel),
                agreementLabel(rel, agreementSeparator)
            ]))
    });
export const resolveFromMap = (map, cell)=>{
    if (typeof cell !== 'string') return {
        status: 'unresolved'
    };
    const name = map.get(cell);
    if (name == null) return {
        status: 'unresolved'
    };
    // WHY: a found-but-blank name is 'empty' (neutral placeholder); a miss is 'unresolved' (raw-id fallback) — only map membership tells them apart.
    return isBlank(name) ? {
        status: 'empty'
    } : {
        status: 'resolved',
        name
    };
};
export const resolveEntityCell = (entityRef, cell, maps)=>resolveFromMap(entityRef === 'client' ? maps.clientMap : maps.agreementMap, cell);
export const resolveByValue = (cell, maps)=>{
    const fromClient = resolveFromMap(maps.clientMap, cell);
    return fromClient.status === 'unresolved' ? resolveFromMap(maps.agreementMap, cell) : fromClient;
};
